// TODO: undo inheritance of this component

import React from 'react';

import {AddEventCode} from '../AddEventCode';
import {connectI18n} from '../../connects';
import Blocklink from '../../elements/Blocklink';
import HomeLogo from '../../elements/HomeLogo';
import Input from '../../elements/forms/Input';
import Screen from '../Screen';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';

class NewAccount extends AddEventCode {
    render() {
        var i18n = this.props.i18n,
            header = (
                <>
                    <TopBar returnURL="/"></TopBar>
                    <HomeLogo></HomeLogo>
                    <hr />
                </>
            );

        return (
            <Screen header={header}>
                <Scrollable>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <h1>{i18n['label.add.event']}</h1>
                        <div className="content">
                            <br />
                            {i18n['label.eventcode.explain.line1'].split('.').map((str, i) => (
                                <p key={i}>{str}.</p>
                            ))}
                            <Input
                                name="code"
                                placeholder={i18n['label.enter.eventcode']}
                                value={this.state.code}
                                onChange={this.handleChange.bind(this, 'code')}
                            />
                            <br />
                        </div>
                        <Blocklink right next type="submit">
                            {i18n['label.go.eventcode']}
                        </Blocklink>
                    </form>
                    <br />
                    <Blocklink right next href="/events/missing_code">
                        {i18n['label.not.have.eventcode']}
                    </Blocklink>
                </Scrollable>
            </Screen>
        );
    }
}

export default connectI18n(NewAccount);
